module.exports = __webpack_public_path__ + "img/Trading-PNG-Photo.0170e22f.png";